/**
 * O que chega da rota `/cadastro/achados/{tipo}/{id}` — e o que deliberadamente NÃO chega.
 *
 * O achado não traz frase nem nome de entidade. Traz números, referências e a evidência; a frase
 * mora em `frases.tsx` e o nome vem no mapa `rotulos`, ao lado. Se o backend pudesse mandar texto,
 * mandaria — e o terceiro domínio escreveria «esteve na casa de Fulano», que é uma precisão de
 * porta que a medida não tem.
 */

/**
 * Medida ou padrão repetido (`forte`) versus pista para conferir (`fraco`). Quem decide é o
 * servidor: a tela testava `metodo !== 'logradouro'`, conhecendo por acaso o vocabulário interno do
 * motor de correlação — o que o segundo domínio não teria como acertar.
 */
export type Forca = 'forte' | 'fraco';

/** Uma entidade de qualquer tipo: `['pessoa', '<uuid>']`. Vira link por `rotaEntidade`. */
export type RefEntidade = [tipo: string, id: string];

export type Achado = {
  /** Id estável da regra — é a chave da frase. */
  regra: string;
  dominio: string;
  forca: Forca;
  sujeito: RefEntidade;
  /** As entidades que a frase cita, NA ORDEM em que ela as cita. */
  entidades: RefEntidade[];
  /** Os números que a frase usa: `{duracao_seg}`, `{vezes, dias}`. */
  numeros: Record<string, number>;
  quando: string | null;
  periodo: [string, string] | null;
  evidencia: { via: string; confianca: number; detalhe: Record<string, unknown> };
  /**
   * Identidade do achado — chave de lista. Índice de array muda de significado quando um achado
   * some do meio.
   */
  chave: string;
};

export type RespostaAchados = {
  achados: Achado[];
  /** `"pessoa:<uuid>" → nome`. Ao lado, nunca embutido: nomear é trabalho do registro de donos. */
  rotulos: Record<string, string>;
};

export const chaveRef = ([tipo, id]: RefEntidade): string => `${tipo}:${id}`;
